import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDataAccumulatorForSingleOrder } from "../../context/dataAccumulatorForSingleOrder";

/** Clear retained single-order state when entering a worklist table tab. */
export const WorklistTabLayout = () => {
  const { resetAll } = useDataAccumulatorForSingleOrder();
  const { pathname } = useLocation();

  useEffect(() => {
    resetAll();
  }, [pathname, resetAll]);

  return <Outlet />;
};
